import { getFirestore } from 'firebase/firestore'
import 'firebase/compat/auth'
import firebase from 'firebase/compat/app'

const app = firebase.initializeApp({
	apiKey: process.env.REACT_APP_API_KEY,
	authDomain: process.env.REACT_APP_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_PROJECT_ID,
	storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_MESSAGING_APP_ID,
})

export const db = getFirestore(app)
export const auth = app.auth()
export default app
